module.exports = __webpack_public_path__ + "static/img/KDL_250x250px-BW.8f0d448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/members/KDL_250x250px-BW.png
// module id = 541
// module chunks = 1